import React from 'react'
import ServicesPage from "./common/ServicesPage";
import { Heading } from "@chakra-ui/react";
const JanitorsServices = () => {
  return (
    <div>
      <ServicesPage
         title={
          <Heading
            as="h1"
            textAlign="center"                     // Center text
            px={{ base: 4, md: 8 }}               // Responsive horizontal padding
            fontSize={{ base: "xl", md: "2xl" }} // Responsive font size
            className="services-title"
          >
          Clean spaces start here.  </Heading>
        }
       
       
       
   
        image="/baner (1).png"
        description={
          <>
            <p>
              Our <strong>Janitorial Services</strong> are designed to keep your
              workplace, commercial property, or residential space clean,
              hygienic, and well-maintained. We provide daily, weekly, and
              customized cleaning schedules to suit the needs of offices,
              schools, hospitals, retail outlets, and industrial spaces.
            </p>

            <p style={{ marginTop: "1rem" }}>
              Our team is trained in modern cleaning practices and uses
              eco-friendly products to ensure a healthy and safe environment.
              From dusting and vacuuming to sanitizing high-touch surfaces and
              handling waste disposal, we cover every aspect of professional
              cleaning. Whether you need ongoing janitorial support or a
              one-time deep clean, we’ve got you covered.
            </p>

            <ul style={{ marginTop: "1rem", paddingLeft: "1.2rem" }}>
              <li> Routine office and facility cleaning</li>
              <li> Floor care (sweeping, mopping, vacuuming, polishing)</li>
              <li> Restroom sanitization and supplies replenishment</li>
              <li> Trash removal and waste management</li>
              <li> Eco-friendly cleaning solutions</li>
              <li> Trained and reliable janitorial staff</li>
            </ul>

            <p style={{ marginTop: "1rem" }}>
              With our janitorial services, you can focus on running your
              business while we ensure a spotless, welcoming, and professional
              environment for your employees and visitors.
            </p>
          </>
        }
      />
    </div>
  )
}

export default JanitorsServices
